const pr = new Intl.PluralRules("en-UK", { type: "ordinal" });

const suffixes = new Map([
  ["one", "st"],
  ["two", "nd"],
  ["few", "rd"],
  ["other", "th"],
]);

export function formatOrdinals(n: number) {
  const rule = pr.select(n);
  const suffix = suffixes.get(rule);
  if (n !== 0) return `${n}${suffix}`;
  else return "Ground";
}
